import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getUserPaymentPopupState } from '../../../store/slices/authSlice';
import { getPaymentModalDataLoading, getPaymentModalState, setShowPaymentModal } from '../../../store/slices/modalsSlice';
import { getSubscriptionPlan } from '../../../store/slices/paymentsSlice';
import Modal from '../../common/Modal';
import Spinner from '../../common/Spinner';
import IssuePaymentContent from './popupContent/IssuePaymentContent';
import OfferPaymentContent from './popupContent/OfferPaymentContent';
import PlanPaymentContent from './popupContent/PlanPaymentContent';
import ProductPaymentContent from './popupContent/ProductPaymentContent';
import TrialPaymentContent from './popupContent/TrialPaymentContent';
import styles from './styles.module.scss';

const PaymentModal = () => {
    const dispatch = useDispatch();
    const isShow = useSelector(getPaymentModalState);
    const paymentState = useSelector(getUserPaymentPopupState);
    const plan = useSelector(getSubscriptionPlan);
    const isOfferLoading = useSelector(getPaymentModalDataLoading);
    const isOffer = !!plan?.isOffer;

    const contentConfig = {
        trial: isOffer ? <OfferPaymentContent /> : <TrialPaymentContent />,
        plan: isOffer ? <OfferPaymentContent /> : <PlanPaymentContent />,
        product: <ProductPaymentContent />,
        issue: isOffer ? <OfferPaymentContent /> : <IssuePaymentContent />
    };

    const content = useMemo(() => {
        return isOfferLoading ? <Spinner fill={'#fff'} /> : contentConfig[paymentState];
    }, [paymentState, isOffer, isOfferLoading]);

    const onCloseBtn = () => {
        dispatch(setShowPaymentModal(false));
    };

    return isShow && <Modal children={content} onCloseClick={!isOffer && onCloseBtn} innerStyles={isOffer ? [styles.offerModal] : []} />;
};

export default PaymentModal;
